module.exports = __webpack_public_path__ + "static/img/device2.640c75d9.png";